module.exports = __webpack_public_path__ + "static/media/banner.e9897596.jpg";